import { useI18n } from "hooks/i18n/i18n";
import { useHistory, useLocation } from "react-router-dom";
import { useFocusToInput } from "utility/useFocusToInput";

import { KEYWORD_MAX_COUNT } from "../../constants/keywordMaxCount";
import { hasKeyword } from "../../functions/hasKeyword";
import { getNextQuery } from "./functions/getNextQuery";

import type { Props } from "./props";
import type { FormEventHandler } from "react";

type Input = Props;

export const useThis = (input: Input) => {
  const { keyword } = input;
  const { t } = useI18n();
  const { pathname, search } = useLocation();
  const history = useHistory();
  const canSearch = keyword.length > 0 && hasKeyword(keyword);
  const handleSearch: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const nextQuery = getNextQuery({ keyword, search });
    const location = [pathname, nextQuery].filter(Boolean).join("?");
    history.push(location);
  };

  const inputRef = useFocusToInput();

  const keywordInputTitle = t("search.upperLimitOfKeyword", {
    maxCount: KEYWORD_MAX_COUNT.toString(),
  });

  return {
    canSearch,
    handleSearch,
    inputRef,
    keywordInputTitle,
    t,
  };
};
